import React from 'react'

export default class BaseForm extends React.PureComponent {
	handleSubmit = (values, actions) => {
		const { onSubmit } = this.props
		onSubmit && onSubmit(values, actions)
	}

	handleClick = isValid => {
		const { onClick } = this.props
		onClick && onClick(isValid)
	}

	handleBack = () => {
		const { onBack } = this.props
		onBack && onBack()
	}

	handleChangeStep = () => {
		this.refs.form && this.refs.form.onEnter()
	}

	submit = () => this.refs.form.submit()
}
